__turbopack_context__.v({
  "dots-menu-mobile-view": "SearchAndFilterComponent-module-scss-module__4LyNza__dots-menu-mobile-view",
  "dots-menu-pc-view": "SearchAndFilterComponent-module-scss-module__4LyNza__dots-menu-pc-view",
  "filter-wrapper": "SearchAndFilterComponent-module-scss-module__4LyNza__filter-wrapper",
});
